import script from "./MenuMobileSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMobileSettings.vue?vue&type=script&setup=true&lang=js"

import "./MenuMobileSettings.vue?vue&type=style&index=0&id=36a76ce0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a76ce0"]])

export default __exports__